import type { LucideIcon } from 'lucide-react';
import {
  Building2,
  Warehouse,
  Package,
  Settings,
  Database,
  CreditCard,
  Sparkles,
  PartyPopper,
} from 'lucide-react';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

/**
 * Shared onboarding step constants and utilities
 * Consolidates step definitions to avoid duplication across components
 */

export const ONBOARDING_STEPS = {
  HOW_IT_WORKS: 0,
  SUPPLIERS: 1,
  WAREHOUSES: 2,
  PRODUCTS: 3,
  SETTINGS: 4,
  STOCK_RECOUNT: 5,
  BILLING: 6,
  COMPLETE: 7,
} as const;

export interface StepDefinition {
  key: string;
  label: string;
  required: boolean;
  icon: LucideIcon;
}

export const STEP_DEFINITIONS: StepDefinition[] = [
  { key: 'how-it-works', label: 'How It Works', required: true, icon: Sparkles },
  { key: 'suppliers', label: 'Suppliers', required: false, icon: Building2 },
  { key: 'warehouses', label: 'Warehouses', required: true, icon: Warehouse },
  { key: 'products', label: 'Products', required: true, icon: Package },
  { key: 'settings', label: 'Settings', required: true, icon: Settings },
  { key: 'stock-recount', label: 'Inventory Baseline', required: false, icon: Database },
  { key: 'billing', label: 'Billing', required: true, icon: CreditCard },
  { key: 'complete', label: 'Complete', required: true, icon: PartyPopper },
];

export const TOTAL_STEPS = 8;

/**
 * Get the path for a given step number.
 * Now always returns the onboarding root since it's a single-page flow.
 */
export function getStepPath(_stepNumber: number): string {
  return paths.onboarding.root;
}
